export const REQUEST_LOCAL_SALARY = 'REQUEST_LOCAL_SALARY';
export const RECIEVE_LOCAL_SALARY = 'RECIEVE_LOCAL_SALARY';
export const REQUEST_LOCAL_SALARY_ERROR = 'REQUEST_LOCAL_SALARY_ERROR';
